var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/core-js/internals/path.js
// module id = lCww
// module chunks = a74a